import styled from "styled-components";

export const RelatedArticlesContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 80px;
`;
